import React, { useState } from 'react';
import { Layout, Form, Input, Button, Switch, notification } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { CheckOutlined } from '@ant-design/icons';

import { storeSelector } from 'reduxStore/store/selectors';
import WorkingTimeSetting from './WorkingTimeSetting';
import ModalConfirmOpenStore from './ModalConfirmOpenStore';
import storeAction from 'reduxStore/store/actions';
import useAPILoading from 'hooks/useAPILoading';
import { updateSettings } from 'APIService/storeSetting';
import { SETTING_AVAILABILITY } from 'variables';
const { Content } = Layout;

const layout = { labelCol: { span: 4 }, wrapperCol: { span: 6 } };
const tailLayout = {
  wrapperCol: { xs: { offset: 0, span: 6 }, md: { offset: 4, span: 6 } },
};
const settingTimeLayout = {
  wrapperCol: { xs: { span: 24 }, md: { offset: 3, span: 21 } },
};

const PageSetting = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [showConfirm, setShowConfirm] = useState(false);
  const storeSetting = useSelector(storeSelector);
  const [requestUpdateSettings, loading] = useAPILoading(updateSettings, false);

  const onFinish = ({ open_day, is_available }) => {
    // transform open_day to appropriate format
    const transformedOpenDay = {};
    for (let day in open_day) {
      const { shifts = [] } = open_day[day];
      const temp = {};
      // remove null shift
      temp.shifts = shifts.filter(Boolean);
      // assign to transformedOpenDay
      transformedOpenDay[day] = temp;
    }

    // transform is_available from boolean to string
    const transformedIsAvailable = is_available
      ? SETTING_AVAILABILITY.AVAILABLE
      : SETTING_AVAILABILITY.UNAVAILABLE;

    const newSettings = {
      open_day: transformedOpenDay,
      is_available: transformedIsAvailable,
    };
    requestUpdateSettings(newSettings)
      .then(() => {
        // update redux with original data
        dispatch(storeAction.updateStore({ open_day, is_available }));
        notification.success({
          message: t('updateSettingsSuccess'),
          placement: 'bottomRight',
        });
      })
      .catch(() => {
        notification.error({
          message: t('error:updateSettingsFailed'),
          placement: 'bottomRight',
        });
      });
  };

  const onShowConfirm = () => {
    setShowConfirm(true);
  };

  const onCancel = () => {
    setShowConfirm(false);
  };

  return (
    <Content
      style={{
        padding: 20,
        background: 'white',
        borderTop: '1px black solid',
      }}>
      <Form
        {...layout}
        colon={false}
        layout='horizontal'
        scrollToFirstError
        onFinish={onFinish}
        initialValues={storeSetting}>
        <Form.Item name='id' label={t('storeID')}>
          <Input disabled />
        </Form.Item>
        <Form.Item name='store_name' label={t('storeName')}>
          <Input disabled />
        </Form.Item>
        <Form.Item name='address' label={t('address')}>
          <Input disabled />
        </Form.Item>

        <Form.Item label={t('online')} dependencies={['is_available']}>
          {(form) => {
            const is_available = form.getFieldValue('is_available');

            return <Switch checked={is_available} onClick={onShowConfirm} />;
          }}
        </Form.Item>
        <Form.Item dependencies={['is_available']} {...settingTimeLayout}>
          {(form) => {
            const is_available = form.getFieldValue('is_available');

            return <WorkingTimeSetting is_available={is_available} />;
          }}
        </Form.Item>

        <Form.Item {...tailLayout}>
          <Button
            block
            type='primary'
            htmlType='submit'
            loading={loading}
            icon={<CheckOutlined />}></Button>
        </Form.Item>
        <Form.Item name='is_available'>
          <ModalConfirmOpenStore visible={showConfirm} onCancel={onCancel} />
        </Form.Item>
      </Form>
    </Content>
  );
};

export default PageSetting;
